// TODO: DSTooltip 사용 검토 필요

import classNames from 'classnames'
import React from 'react'

interface StaticTooltipProps {
  clx?: string | string[]
  style?: React.CSSProperties
  text: string | React.ReactNode
  bgDanger?: boolean
  bgBlack?: boolean
  isTop?: boolean
  onClick?: () => void
}
const StaticTooltip = ({ clx, style, text, bgDanger, bgBlack, isTop, onClick }: StaticTooltipProps) => {
  return (
    <div className="relative" onClick={onClick}>
      <div
        style={style}
        className={classNames(
          clx,
          { 'bg-purple-500': !bgDanger },
          { 'bg-red-500': bgDanger },
          [isTop ? 'chat-bubble-top' : 'chat-bubble', bgDanger && 'danger', bgBlack && 'black bg-black bg-opacity-80'],
          'text-h6 absolute whitespace-nowrap rounded py-[8px] px-[16px] text-center text-white'
        )}
      >
        {text}
      </div>
    </div>
  )
}

export default StaticTooltip
